import groupRouterPaths from './groupRouterPaths';

export default groupRouterPaths;
